module.exports = __webpack_public_path__ + "static/media/iconMobile.f1916314.png";